import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Formik, Form } from 'formik';
import {
  Box,
  Button,
  Grid,
  Container,
  Typography,
  CircularProgress,
  makeStyles
} from "@material-ui/core";
import UserRegisterStyle from "./userRegisterStyle";
import FormField from "../FormField/FormField";
import { Creators as UserActions } from "../../store/ducks/users";
import { userSchema } from "../../utils/schemas/userSchema";
import { notifySuccess } from "../../utils/js/helpers";
import { COLORS } from "../../utils/js/constants";

const useStyles = makeStyles((theme) => UserRegisterStyle(theme));

const UserRegister = ({ createNewUserWithEmailAndPassword, users, onFinished }) => {
  const [loading, setLoading] = useState(false)
  const classes = useStyles();

  useEffect(() => {
    const { type, loading } = users

    setLoading(loading)

    if (type === "users/ADD") {
      notifySuccess('Usuário adicionado!');
      onFinished()
    }
  }, [onFinished, users])

  const handleSubmit = useCallback((user) => {
    setLoading(true)
    const { name, email, password } = user;
    createNewUserWithEmailAndPassword(name, email, password)
  }, [createNewUserWithEmailAndPassword])

  const loadingElement = () => (<>
    <span>Aguarde </span>
    <CircularProgress style={{color: COLORS.white}} size={12} />
  </>)

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} variant="h6" component="h2">
        Digite as informações do novo usuário
      </Typography>

      <Formik
        initialValues={userSchema.getDefaultFromShape()}
        validationSchema={userSchema}
        onSubmit={(values) => handleSubmit(values)}
      >{() => (
        <Form>
          <Grid container item direction="column">
            <Grid item>
              <FormField
                name="name"
                type="text"
                label="Nome do Usuário"
                variant="outlined"
                fullWidth
                required
              />
            </Grid>

            <Grid item>
              <FormField
                name="email"
                type="email"
                label="E-mail do Usuário"
                variant="outlined"
                fullWidth
                required
              />
            </Grid>

            <Grid item>
              <FormField
                name="password"
                type="password"
                label="Digite a Senha"
                variant="outlined"
                fullWidth
                required
              />
            </Grid>

            <Grid item>
              <FormField
                name="confirm_password"
                type="password"
                label="Confirme a Senha"
                variant="outlined"
                fullWidth
                required
              />
            </Grid>
          </Grid>

          <Container>
            <Button
              className={classes.submitButton}
              type="submit"
              variant="contained"
              disabled={loading}
            >
              { loading ? loadingElement() : "Cadastrar" }
            </Button>
          </Container>
        </Form>
      )}</Formik>
    </Box>
  );
};

const mapStateToProps = ({ users }) => ({ users })
const mapDispatchToProps = dispatch => {
  const { createNewUserWithEmailAndPassword } = UserActions
  return bindActionCreators({
    createNewUserWithEmailAndPassword
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegister);
